import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { Spinner } from "@phosphor-icons/react";

export default function Reorder() {
  const [params] = useSearchParams();
  const { add } = useCart();
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const raw = params.get("items") || "";
    const pairs = raw.split(",").map((s) => s.split(":")).filter((a) => a[0]);
    if (!pairs.length) { nav("/shop"); return; }
    (async () => {
      let added = 0;
      const skipped = [];
      for (const [pid, qtyStr] of pairs) {
        try {
          const { data: p } = await api.get(`/products/${pid}`);
          if (!p || p.active === false || Number(p.stock) <= 0) { skipped.push(p?.name || "an item"); continue; }
          add({ id: p.id, name: p.name, price: p.price, image_url: p.image_url || "" }, Math.max(1, parseInt(qtyStr, 10) || 1));
          added += 1;
        } catch {
          skipped.push("an item");
        }
      }
      if (added === 0) toast.error("These items are no longer available");
      else if (skipped.length) toast.warning(`Added ${added} item(s). Some were unavailable.`);
      else toast.success("Items added to your cart");
      nav("/cart");
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="reorder-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      <Spinner size={28} className="animate-spin text-primary mx-auto mb-4" />
      <p className="font-mono text-muted-foreground text-sm">Adding your items to the cart…</p>
    </div>
  );
}
